import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-refundable-ticket',
    templateUrl: './refundable-ticket.component.html',
    styleUrls: ['./refundable-ticket.component.scss']
})
export class RefundableTicketComponent {
    companyName = '';

    constructor(private http: HttpClient) {
        this.companyName = environment.name;
    }

    redirectToRefundForm() {
        window.open('https://app.pipefy.com/public/form/FxkoHIhK', '_blank');
    }
}
